import axios from 'axios';
import { toast } from 'sonner';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const openBlob = async (path, headers) => {
  const win = window.open('', '_blank');
  try {
    const r = await axios.get(`${API}${path}`, { headers, responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    if (win) win.location.href = url; else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
    if (win) win.close();
    toast.error('Document indisponible');
  }
};

export const downloadBlob = async (path, headers, filename) => {
  try {
    const r = await axios.get(`${API}${path}`, { headers, responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    Object.assign(document.createElement('a'), { href: url, download: filename }).click();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  } catch { toast.error('Téléchargement impossible'); }
};

export const PRODUITS_FILTRE = [['', 'Tous'], ['rcds', 'RCDS'], ['domium', 'DOS-DOMIUM'], ['ftpe', 'FTPE']];

export const prevMonth = () => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - 1); return d.toISOString().slice(0, 7); };
